/**
 * React Query hook for the Inspections listing.
 *
 * Contract requirements:
 *  - keepPreviousData: true → stale data stays visible while new page is loading.
 *  - Errors are not swallowed — they propagate to React Query `error` state.
 *  - The QueryClient is created outside the render body by the feature mount (task-08);
 *    this hook only consumes it via useQuery.
 *  - Query key is built deterministically by inspectionsQueryKey().
 */
import { useQuery } from '@tanstack/react-query';
import { fetchInspections } from '../services/InspectionsService';
import { inspectionsKeys } from './queryKeys';
/**
 * Fetches inspections for the given normalized state.
 *
 * Errors thrown by fetchInspections() are surfaced as `error` in the returned
 * query result — callers must handle the error state explicitly (no swallowing).
 */
export function useInspectionsQuery(state, options = {}) {
    return useQuery(inspectionsKeys.listing(state), () => fetchInspections(state), {
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        enabled: options.enabled !== false
        // Errors propagate — do NOT add onError swallowing
    });
}
